import React from 'react';
import { Box, Grid, Paper, Typography } from '@mui/material';

import { useAppDispatch } from 'store/store.hook';
import { updateLayout } from 'store/slices/layout.slice';
import { ReportsPageContextProvider } from './reports-page.context';
import { ReportsBuildingSelector } from './reports-building-selector';
import { ReportsTable } from './reports-table';
import { ReportsDateRangePicker } from './reports-date-range-picker';

export const ReportsPage = () => {
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    dispatch(
      updateLayout({
        headerTitle: 'Reporting',
      }),
    );
  }, []);

  return (
    <ReportsPageContextProvider>
      <Box sx={{ padding: 3 }}>
        <Typography sx={{ marginBottom: 2 }}>Report Filters</Typography>

        <Grid container spacing={4} sx={{ paddingTop: 2 }}>
          <Grid item xs={12} lg={5}>
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <ReportsDateRangePicker />
              </Grid>

              <Grid item xs={12}>
                <ReportsBuildingSelector />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} lg={7}>
            <Paper sx={{ padding: { xs: 0, sm: 3 } }}>
              <Box sx={{ paddingX: { xs: 1, sm: 0 }, paddingBottom: 2, paddingTop: { xs: 3, sm: 0 } }}>
                <Typography>Report Results</Typography>
              </Box>

              <ReportsTable />
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </ReportsPageContextProvider>
  );
};
